<template>
    <div class="border border-gray-200 rounded-lg shadow-sm">
        <button
            @click="open = !open"
            class="w-full px-4 py-3 text-left font-semibold text-gray-800 bg-gray-100 hover:bg-gray-200 flex justify-between items-center"
        >
            <slot name="title" />
            <svg
                class="w-5 h-5 transform transition-transform"
                :class="{ 'rotate-180': open }"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
            >
                <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M19 9l-7 7-7-7"
                />
            </svg>
        </button>
        <transition name="fade">
            <div
                v-show="open"
                class="p-4"
            >
                <slot />
            </div>
        </transition>
    </div>
</template>

<script>
    export default {
        name: 'Disclosure',
        props: {
            defaultOpen: {
                type: Boolean,
                default: false,
            },
        },
        data() {
            return {
                open: this.defaultOpen,
            };
        },
    };
</script>

<style scoped>
    .fade-enter-active,
    .fade-leave-active {
        transition: all 0.3s ease;
    }
    .fade-enter,
    .fade-leave-to {
        opacity: 0;
        transform: scale(0.98);
    }
</style>
